import AuthenticatedAPIClient from '../lib/AuthenticatedAPIClient';
import UserStore from '../stores/UserStore';
import PassengerAssistStore from '../stores/PassengerAssistStore';

const PassengerAssist = {
    async getAccessibilityProfile () {
        const user = UserStore.getCurrent();

        const endpoint = `/travel-assist/customer/${user.id}/accessibility-profile`;
        return await AuthenticatedAPIClient.get(endpoint);
    },

    async createAccessibilityProfile(payload) {
        const user = UserStore.getCurrent();

        const endpoint = `/travel-assist/customer/${user.id}/accessibility-profile`;
        return await AuthenticatedAPIClient.post(endpoint, payload);
    },

    async deleteAccessibilityProfile() {
        const user = UserStore.getCurrent();
        const accessibilityProfileId = PassengerAssistStore.getAccessibilityProfileId();

        const endpoint = `/travel-assist/customer/${user.id}/accessibility-profile/${accessibilityProfileId}`;
        return await AuthenticatedAPIClient.delete(endpoint);
    },

    async updateAccessibilityProfile(payload) {
        const user = UserStore.getCurrent();
        const accessibilityProfileId = PassengerAssistStore.getAccessibilityProfileId();

        const endpoint = `/travel-assist/customer/${user.id}/accessibility-profile/${accessibilityProfileId}`;
        return await AuthenticatedAPIClient.put(endpoint, payload);
    },

    async getPreviousJourneys (date, size = 5) {
        const user = UserStore.getCurrent();

        const endpoint = `/travel-assist/${user.id}/previous-journeys/?size=${size}&date=${date}`;
        return await AuthenticatedAPIClient.get(endpoint);
    },

    async getAssistedTravelLocation (nlc) {
        const endpoint = `/travel-assist/assisted-travel/location?nlc=${nlc}`;
        return await AuthenticatedAPIClient.get(endpoint);
    },

    async bookAssist(payload) {
        const user = UserStore.getCurrent();

        const endpoint = `/travel-assist/${user.id}/assisted-travel/create`;
        return await AuthenticatedAPIClient.post(endpoint, payload);
    },

    async bookManyAssists(payload) {
        const user = UserStore.getCurrent();

        const endpoint = `/travel-assist/${user.id}/assisted-travel/create-many`;
        return await AuthenticatedAPIClient.post(endpoint, payload);
    },

    async getAssistedBooking (sysId) {
        const user = UserStore.getCurrent();

        const endpoint = `travel-assist/${user.id}/assisted-travel/${sysId}`;
        return await AuthenticatedAPIClient.get(endpoint);
    },

    async getAssistedBookings () {
        const user = UserStore.getCurrent();

        const endpoint = `travel-assist/${user.id}/assisted-travels/requests`;
        return await AuthenticatedAPIClient.get(endpoint);
    },

    async cancelAssistedBooking (sysId) {
        const user = UserStore.getCurrent();

        const endpoint = `/travel-assist/${user.id}/assisted-travel/${sysId}/cancel`;
        return await AuthenticatedAPIClient.put(endpoint);
    },

    async editAssistedBooking (payload) {
        const user = UserStore.getCurrent();
        const { sysId } = payload;

        const endpoint = `/travel-assist/${user.id}/assisted-travel/${sysId}/update`;
        return await AuthenticatedAPIClient.put(endpoint, payload);
    },
};

export default PassengerAssist;



// WEBPACK FOOTER //
// ./src/services/PassengerAssistService.js